import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import style from "css/realtime.module.css";
import { Modal, Tabs, Table, Space, Input, Button, Select, Empty } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import { useTranslation } from "react-i18next";

function CmsAddEndpointModal(props) {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [isLoading, setLoading] = useState(false);
    const [endpointList, setEndpointList] = useState([]);
    const [registEndpointOption, setRegistEndpointOption] = useState("");
    const [registEndpoints, setRegistEndpoins] = useState([]);
    const [unregistEndpoint, setUnregistEndpoint] = useState([]);
    const [unRegistEndpointOption, setUnRegistEndpointOption] = useState({
        name: "",
        ip: "",
        key: ""
    });

    const columns = [
        {
            title: "",
            dataIndex: "REMOVE",
            key: "REMOVE",
            align: "center",
            width: "15%",
            render: (_, el) => (
                <>
                    <CloseCircleOutlined
                        style={{ fontSize: "18px" }}
                        onClick={() =>
                            setRegistEndpoins(
                                registEndpoints.filter((endpoint) => endpoint.key !== el.key)
                            )
                        }
                    />
                </>
            ),
        },
        {
            title: t("LIST.DEVICE_NAME"),
            key: "name",
            dataIndex: "name",
            width: "40%",
        },
        {
            title: t("LIST.DEVICE_IP"),
            key: "ip",
            dataIndex: "ip",
            width: "45%",
        },
    ];

    let items = [
        {
            key: "REGIST_ENDPOINT_TAB",
            label: t("LABEL.REGISTERED_DEVICE"),
            children: (
                <div className={style.regist_endpoint}>
                    <Select
                        showSearch
                        size="large"
                        placeholder="Search to select"
                        optionFilterProp="children"
                        value={registEndpointOption}
                        filterOption={(input, option) =>
                            (option?.label ?? "").includes(input)
                        }
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? "")
                                .toLowerCase()
                                .localeCompare((optionB?.label ?? "").toLowerCase())
                        }
                        // onInputKeyDown={(input, option) => {
                        //   console.log(input, option);
                        //   if (input.key === "Enter") {
                        //     console.log(input.currentTarget.value);
                        //     console.log(
                        //       (option?.label ?? "").includes(input.currentTarget.value)
                        //     );
                        //     // if((option?.label ?? "").includes(e.currentTarget.value))
                        //   }
                        // }}

                        onInputKeyDown={(input, option) => {
                            if (input.key === "Enter") {
                                if (
                                    registEndpoints.find(
                                        (endpoint) => endpoint.ip === option.ip
                                    )
                                ) {
                                    const obj = {
                                        title: t("MESSAGE.NOTIFICATION"),
                                        content: t("MESSAGE.ALREADY_ADDED_DEVICE"),
                                        submitEventHandler: () => {
                                            dispatch(closeAlert());
                                        },
                                    };
                                    dispatch(openAlert(obj));
                                    return;
                                }
                                setRegistEndpoins([...registEndpoints, option]);
                                setRegistEndpointOption("");
                            }
                        }}
                        onSelect={(value, option) => {
                            if (
                                registEndpoints.find(
                                    (endpoint) => endpoint.ip === option.ip
                                )
                            ) {
                                const obj = {
                                    title: t("MESSAGE.NOTIFICATION"),
                                    content: t("MESSAGE.ALREADY_ADDED_DEVICE"),
                                    submitEventHandler: () => {
                                        dispatch(closeAlert());
                                    },
                                };
                                dispatch(openAlert(obj));
                                return;
                            }
                            setRegistEndpoins([...registEndpoints, option]);
                            setRegistEndpointOption("");
                        }}
                        options={endpointList}
                    />

                    <Table
                        rowKey={(item) => item.key}
                        className={style.registEndpoint_table}
                        columns={columns}
                        pagination={false}
                        style={{
                            height: "200px",
                        }}
                        scroll={{
                            y: 140,
                        }}
                        dataSource={registEndpoints}
                        loading={isLoading}
                        locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
                    />
                </div>
            ),
        },
        {
            key: "UNREGIST_ENDPOINT_TAB",
            label: t("LABEL.UNREGISTERED_DEVICE"),
            children: (
                <div className={style.unregist_endpoint}>
                    <Space.Compact size="large">
                        <Input
                            placeholder={t("LIST.DEVICE_NAME")}
                            style={{ width: "40%" }}
                            value={unRegistEndpointOption.name}
                            onChange={(e) =>
                                setUnRegistEndpointOption({
                                    ...unRegistEndpointOption,
                                    name: e.currentTarget.value,
                                })
                            }
                        />
                        <Input
                            placeholder={t("LIST.DEVICE_IP")}
                            style={{ width: "60%" }}
                            value={unRegistEndpointOption.ip}
                            onChange={(e) =>
                                setUnRegistEndpointOption({
                                    ...unRegistEndpointOption,
                                    key: e.currentTarget.value,
                                    ip: e.currentTarget.value,
                                })
                            }
                        />
                        <Button
                            type="primary"
                            disabled={
                                unRegistEndpointOption.name === "" ||
                                    unRegistEndpointOption.ip === ""
                                    ? true
                                    : false
                            }
                            onClick={() => {
                                if (
                                    unregistEndpoint.find(
                                        (endpoint) =>
                                            endpoint.ip === unregistEndpoint.ip
                                    )
                                ) {
                                    const obj = {
                                        title: t("MESSAGE.NOTIFICATION"),
                                        content: t("MESSAGE.ALREADY_ADDED_DEVICE"),
                                        submitEventHandler: () => {
                                            dispatch(closeAlert());
                                        },
                                    };
                                    dispatch(openAlert(obj));
                                    return;
                                }
                                setUnregistEndpoint([...unregistEndpoint, unRegistEndpointOption]);
                                setUnRegistEndpointOption({
                                    name: "",
                                    key: "",
                                    ip: "",
                                });
                            }}
                        >
                            {t("BTN.ADD")}
                        </Button>
                    </Space.Compact>

                    <Table
                        rowKey={(item) => item.key}
                        className={style.unregistEndpoint_table}
                        columns={columns}
                        pagination={false}
                        style={{
                            height: "200px",
                        }}
                        scroll={{
                            y: 140,
                        }}
                        dataSource={unregistEndpoint}
                        loading={isLoading}
                        locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
                    />
                </div>
            ),
        },
    ];

    const getEndpoint = useCallback(() => {
        setLoading(true);
        let url = "/active/endpoint";

        axios.get(url)
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.length > 0) {
                        let endpoints = [];
                        endpoints = res.data.map((data) => {
                            return {
                                ...data,
                                key: data.ip,
                                label: data.name,
                                value: data.ip,
                            };
                        });
                        setEndpointList(endpoints);
                    }
                }
            })
            .finally(() => {
                setLoading(false);
            })
    }, []);

    useEffect(() => {
        if (props.open) {
            getEndpoint();
            setRegistEndpoins([]);
            setRegistEndpointOption("");
            setUnregistEndpoint([]);
            setUnRegistEndpointOption({
                name: "",
                key: "",
                ip: "",
            });
        }

    }, [getEndpoint, props.open]);

    const addEndpoint = () => {
        const endpointList = [...registEndpoints, ...unregistEndpoint];

        const data = {
            endpoint_list: endpointList,
            call_id: props.callId
        }

        axios.post("/active/endpoint", data)
            .then(
                res => {
                    if (res.status === 200) {
                        console.log("success");
                    }
                }
            )
    }

    return (
        <Modal
            centered
            title={t("BTN.ADD_DEVICE")}
            open={props.open}
            onCancel={props.close}
            okText={t("BTN.ADD")}
            cancelText={t("common.button.cancel")}
            okButtonProps={{
                onClick: () => {
                    addEndpoint();
                },
                loading: isLoading
            }}
            cancelButtonProps={{
                loading: isLoading
            }}
        >
            <Tabs
                centered
                defaultActiveKey="REGIST_ENDPOINT_TAB"
                size="large"
                items={items}
            />
        </Modal>
    );
}

export default CmsAddEndpointModal
